export enum EditorContext {
    STANDARD = 1,
    CONTENT_AUTHORING = 2,
}
